/**
 * Guarded localStorage access. Both reads and writes swallow failures
 * (no `window`, privacy mode, quota) because every persisted value here is a
 * non-critical preference with a sensible default.
 */

export function readStored(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStored(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // persistence is non-critical
  }
}
